import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import getById from 'utils/DOM/getById'

function getTemplate(id) {
  const node = getById(id)

  return node ? Templater(node.innerText) : ''
}

export default getTemplate
